import type {DataMessagePartComponent} from '@assistant-ui/react';
import {useTruncate} from '@wandb/components';
import React, {useRef} from 'react';

import type {WandbRunPart} from '../../../agentChat/store/thread';
import {MentionPill} from './MentionPill';

/** RunMentionPart renders a run mention as a truncating pill. */
export const RunMentionPart: DataMessagePartComponent<WandbRunPart> = ({
  data,
}) => {
  const ref = useRef<HTMLSpanElement>(null);
  const displayText = data.runDisplayName ?? data.runName;
  const {text: truncated, isTruncated} = useTruncate(displayText, {ref});

  return (
    // Inline wrapper so the pill flows with the surrounding text
    // while still giving `useTruncate` a ref.
    <span
      ref={ref}
      style={{
        display: 'inline-block',
        maxWidth: '100%',
        verticalAlign: 'middle',
      }}>
      <MentionPill
        icon="running-repeat"
        text={truncated}
        tooltip={isTruncated ? {children: displayText} : undefined}
      />
    </span>
  );
};
